import React from 'react'

import { Field } from 'formik'

import { Col, Form, Button, Row } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import { KeyEventUtil } from 'utils'

import * as TablasPersonalizadasService from 'services/tablasPersonalizadas.service'

const MedioPagoFormGroup = ({ iError, iTouched, iValue, fIsSubmitting }) => {
  const [mostrarAyuda, setMostrarAyuda] = React.useState(false)
  const [mediosOptions, setMediosOptions] = React.useState([])
  const [listaMediosPago, setListaMediosPago] = React.useState([])

  const medioPagoRef = React.useRef(null)

  React.useEffect(() => {
    TablasPersonalizadasService.getAsSelect(TiposTablaPersonalizadaConstant.MEDIOSPAGO).then(({ data }) => {
      if (data && data.length > 0) {
        setListaMediosPago(data)
        setMediosOptions(
          data.map((x, k) => (
            <option key={k} value={x._id}>
              {x.nombre}
            </option>
          ))
        )
      }
    })
  }, [])

  React.useEffect(() => {
    setTimeout(() => {
      medioPagoRef.current.focus()
    }, 200)
  }, [])

  const medioPagoText = React.useMemo(() => {
    const matchDoc = listaMediosPago.find(x => x._id === iValue)

    if (matchDoc) {
      return matchDoc.nombre
    } else {
      return '--'
    }
  }, [iValue, listaMediosPago])

  const clickAyuda = React.useCallback(() => {
    setMostrarAyuda(true)
  }, [])

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-numeroDocumentoPago', e)
  }, [])

  const onSelectKeyDown = React.useCallback(e => {
    if (e.keyCode === 13 || e.keyCode === 9) {
      e.preventDefault()
      setMostrarAyuda(false)
      KeyEventUtil.leaveOnKeyEvent('input-numeroDocumentoPago')
    }
  }, [])

  return (
    <Row>
      <Col md={12}>
        <Form.Group>
          <Form.Label text='MEDIO DE PAGO' htmlFor='select-medioDePago' md={12} />
          <Col md={12}>
            {mostrarAyuda ? (
              <Field name='medioDePago'>
                {({ field }) => (
                  <Form.Select {...field} id='select-medioDePago' isInvalid={iTouched && iError} disabled={fIsSubmitting} onKeyDown={onSelectKeyDown}>
                    <option value=''>Seleccionar</option>
                    {mediosOptions}
                  </Form.Select>
                )}
              </Field>
            ) : (
              <Form.InputGroup>
                <Field name='medioDePago'>
                  {({ field }) => (
                    <Form.InputText
                      {...field}
                      id='input-medioDePago'
                      ref={medioPagoRef}
                      isInvalid={iTouched && iError}
                      disabled={fIsSubmitting}
                      onKeyDown={onKeyDown}
                      maxLength={3}
                    />
                  )}
                </Field>
                <Form.InputGroup.Append>
                  <Button onClick={clickAyuda}>&#x1F892;</Button>
                </Form.InputGroup.Append>
                {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
              </Form.InputGroup>
            )}
          </Col>
        </Form.Group>
      </Col>
      <Col md={12}>
        <Form.OnlyText text={medioPagoText} />
      </Col>
    </Row>
  )
}

export default React.memo(MedioPagoFormGroup)
